import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Services } from './components/Services';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-olive selection:text-cream" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Services data-id="element-5" />
        <Team data-id="element-6" />
        <Testimonials data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
      <FloatingWhatsApp data-id="element-9" />
    </div>;
}